module.exports = __webpack_public_path__ + "img/gzh.a7c1eec7.jpg";